import { Component, OnInit } from '@angular/core';
import { LeaseDetailService } from "@modules/private/lease/data/services/view/lease-detail.service";
import { ApiLeaseService } from '../../data/services/api/api-lease.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-lease-negotiation',
  templateUrl: './lease-negotiation.component.html',
  styleUrls: ['./lease-negotiation.component.scss'],
  providers: [MessageService]
})
export class LeaseNegotiationComponent implements OnInit {
  constructor(
    public leaseDetailService: LeaseDetailService,
    private apiLeaseService: ApiLeaseService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.populateForm()
  }

  populateForm() {
    const data = this.leaseDetailService.data as any
    if (data) {
      this.leaseDetailService.entityNegotiation.patchValue({
        guaranty: data.negotiation.guarantee || '',
        totalValue: data.negotiation.totalValue || '',
        file: data.negotiation.document || ''
      });
    }
  }

  get e() {
    return this.leaseDetailService.entityNegotiation
  }

  get data() {
    return this.leaseDetailService.data as any
  }

  /**
   * Manejar cuando se sube un archivo de negociación
   */
  onFileSelected(fileUrl: string): void {
    // Actualizar el FormControl
    this.leaseDetailService.entityNegotiation.patchValue({
      file: fileUrl
    });

    // Guardar automáticamente
    this.saveNegotiationDocument();
  }

  /**
   * Manejar cuando se elimina un archivo de negociación
   */
  onFileDeleted(): void {
    // Limpiar el FormControl
    this.leaseDetailService.entityNegotiation.patchValue({
      file: ''
    });

    // Guardar automáticamente
    this.saveNegotiationDocument();
  }

  /**
   * Manejar descarga de archivos
   */
  onDownloadRequested(fileUrl: string): void {
    this.apiLeaseService.downloadDocumentByUrl(fileUrl).subscribe({
      next: (blob) => {
        if (!blob || blob.size === 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'El archivo descargado está vacío. Intente de nuevo.'
          });
          return;
        }

        const extension = fileUrl.includes('.') ? fileUrl.substring(fileUrl.lastIndexOf('.')) : '';

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'documento_negociacion' + extension;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.messageService.add({
          severity: 'success',
          summary: 'Descarga',
          detail: 'Archivo descargado correctamente.'
        });
      },
      error: (error) => {
        console.error('Error al descargar archivo:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo descargar el archivo.'
        });
      }
    });
  }

  /**
   * Guardar solo el documento de negociación
   */
  private saveNegotiationDocument(): void {
    const negotiationData = {
      negotiation: {
        guarantee: this.leaseDetailService.entityNegotiation.value.guaranty,
        totalValue: this.leaseDetailService.entityNegotiation.value.totalValue,
        document: this.leaseDetailService.entityNegotiation.value.file
      }
    };

    this.apiLeaseService.putCollection(negotiationData, undefined, 'leases/' + this.leaseDetailService.id)
      .subscribe((response) => {
        if (!response.error) {
          this.leaseDetailService.getLeaseDetail();
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Documento actualizado correctamente.'
          });
        }
      });
  }
}
